import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAuth } from '../../contexts/AuthContext';
import { HandoverNotificationPopup } from '../HandoverNotificationPopup';

export const DashboardLayout = ({ title, children }) => {
  const { impersonating } = useAuth();
  
  return (
    <div className={`app-layout ${impersonating ? 'pt-10' : ''}`} data-testid="dashboard-layout">
      <Sidebar />
      <main className="main-content">
        <Header title={title} />
        <div className="page-container animate-fade-in">
          {children}
        </div>
      </main>
      {/* Global handover notification popups */}
      <HandoverNotificationPopup />
    </div>
  );
};
